/**
 * <p-stock-status> — Puschies Lagerstatus + Warenkorb-Button-Zustand (blocks/p-stock-status.liquid), wie Hyper
 * snippets/stock-status.liquid + snippets/buy-buttons.liquid.
 * - Variantenwechsel (Theme productSelect-Event am Abschnitt): Block aus dem neu gerenderten Abschnitt übernehmen.
 * - data-buy-state="soldout": Button „Ausverkauft“ + gesperrt (auch überverkaufte Varianten ohne Nachlieferdatum).
 *   Wird kurz überwacht, weil Theme Formular (resource.available) und das PreOrder-Now-App-Embed (WOD, jQuery)
 *   den Button sonst wieder freischalten.
 * - data-buy-state="preorder": Button „Jetzt vorbestellen“ + versteckte Positions-Eigenschaft
 *   (z. B. „Vorbestellung: Versand am 15.05.2026“) im Produktformular.
 */
import { StandardEvents } from '@shopify/events';

if (!customElements.get('p-stock-status')) {
  const ATTRS = [
    'data-state',
    'data-buy-state',
    'data-sold-out-label',
    'data-preorder-label',
    'data-preorder-property',
    'data-preorder-value',
  ];

  class PStockStatus extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      this.section?.addEventListener(StandardEvents.productSelect, this.onSelect);
      this.applyBuyState();
    }

    disconnectedCallback() {
      this.section?.removeEventListener(StandardEvents.productSelect, this.onSelect);
      this.observer?.disconnect();
    }

    onSelect = (event) => {
      if (event.target instanceof Element && event.target.closest('product-card')) return;
      event.promise
        ?.then(({ detail }) => {
          const next = detail?.html?.querySelector(`p-stock-status[data-block-id="${this.dataset.blockId}"]`);
          if (!next) return;
          this.innerHTML = next.innerHTML;
          for (const name of ATTRS) {
            if (next.hasAttribute(name)) this.setAttribute(name, next.getAttribute(name));
            else this.removeAttribute(name);
          }
          // nach Theme Button-Morph (product-form.js) ausführen
          setTimeout(() => this.applyBuyState(), 0);
        })
        .catch(() => {});
    };

    get button() {
      return this.section?.querySelector('product-form-component [ref="addToCartButton"]');
    }

    setLabel(button, text) {
      const node = [...button.childNodes].find((n) => n.nodeType === 3 && n.textContent.trim());
      if (node && text && node.textContent.trim() !== text) node.textContent = text;
    }

    applyBuyState() {
      this.observer?.disconnect();
      clearTimeout(this.observerTimer);

      const form = this.section?.querySelector('product-form-component form[action*="/cart/add"]');
      const button = this.button;
      if (!form || !button) return;
      form.querySelectorAll('input[data-p-preorder]').forEach((input) => input.remove());

      const state = this.dataset.buyState;
      if (state === 'preorder' && this.dataset.preorderProperty) {
        button.disabled = false;
        this.setLabel(button, this.dataset.preorderLabel);
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${this.dataset.preorderProperty}]`;
        input.value = this.dataset.preorderValue || '';
        input.dataset.pPreorder = '';
        form.appendChild(input);
        return;
      }

      if (state !== 'soldout') return;
      const enforce = () => {
        if (this.dataset.buyState !== 'soldout') return;
        const current = this.button;
        if (!current) return;
        if (!current.disabled) current.disabled = true;
        this.setLabel(current, this.dataset.soldOutLabel);
      };
      enforce();
      this.observer = new MutationObserver(enforce);
      this.observer.observe(button, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        characterData: true,
        subtree: true,
      });
      this.observerTimer = setTimeout(() => this.observer?.disconnect(), 5000);
    }
  }

  customElements.define('p-stock-status', PStockStatus);
}
